import React from 'react';
import { Leaf } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

export function About({ storefrontSettings }) {
    const [aboutRef, aboutRevealed] = useScrollReveal({ threshold: 0.15 });
    const [leftRef, leftRevealed] = useScrollReveal({ threshold: 0.15 });
    const [rightRef, rightRevealed] = useScrollReveal({ threshold: 0.15 });

    return (
        <section id="about" className="py-24 bg-white">
            <div className="max-w-4xl mx-auto px-6 text-center">
                <div ref={aboutRef} className={aboutRevealed ? 'reveal revealed' : 'reveal'}>
                    <h2 className="text-4xl font-serif text-gray-800 mb-2">{storefrontSettings?.aboutTitle || 'Who I Am'}</h2>
                    <div className="h-1 w-24 bg-gradient-to-r from-[#d48c95] to-[#c5a059] mx-auto mb-10 rounded-full"></div>

                    {storefrontSettings?.aboutQuote && (
                        <p className="text-xl text-gray-600 italic mb-10 leading-relaxed">
                            "{storefrontSettings.aboutQuote}"
                        </p>
                    )}
                </div>

                <div className="grid md:grid-cols-2 gap-12 text-left items-center">
                    <div ref={leftRef} className={`space-y-6 text-gray-600 leading-relaxed ${leftRevealed ? 'reveal revealed reveal-delay-1' : 'reveal'}`}>
                        {storefrontSettings?.aboutContent1 && (
                            <p className="text-lg">
                                {storefrontSettings.aboutContent1}
                            </p>
                        )}
                        {storefrontSettings?.aboutContent2 && (
                            <p className="text-lg">
                                {storefrontSettings.aboutContent2}
                            </p>
                        )}
                        {Array.isArray(storefrontSettings?.aboutCredentials) && storefrontSettings.aboutCredentials.length > 0 && (
                            <div className="grid grid-cols-1 gap-3 pt-4">
                                {storefrontSettings.aboutCredentials.map((item, idx) => (
                                    <div key={idx} className="flex items-center text-sm font-medium text-gray-700 hover:text-[#c5a059] transition-colors group">
                                        <Leaf size={16} className="text-[#c5a059] mr-3 group-hover:scale-110 transition-transform" />
                                        {item}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    {(storefrontSettings?.aboutPhilosophy || storefrontSettings?.aboutPhilosophyTitle) && (
                        <div ref={rightRef} className={`bg-[#fdfbf7] p-8 rounded-2xl border border-[#eaddcf] card-hover ${rightRevealed ? 'reveal revealed reveal-delay-2' : 'reveal'}`}>
                            {storefrontSettings.aboutPhilosophyTitle && (
                                <h3 className="text-2xl font-serif text-[#d48c95] mb-4">{storefrontSettings.aboutPhilosophyTitle}</h3>
                            )}
                            {storefrontSettings.aboutPhilosophy && (
                                <p className="text-gray-600 mb-4 leading-relaxed">
                                    {storefrontSettings.aboutPhilosophy}
                                </p>
                            )}
                            {storefrontSettings.aboutPhilosophyAuthor && (
                                <div className="text-[#c5a059] font-serif text-lg">{storefrontSettings.aboutPhilosophyAuthor}</div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default About;
